import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

function ConfirmDialog({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText,
    cancelText,
    confirmColor = 'error'
}) {
    const { t } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title || t('common.confirm')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    {cancelText || t('common.cancel')}
                </Button>
                <Button onClick={handleConfirm} color={confirmColor} variant="contained">
                    {confirmText || t('common.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
